import { addSpacesToTitleCase } from "_shared/_utilities/add-spaces-to-title-case";
import Guid from "_shared/guids/guid";
import { BaseResourceParams, ResourceType } from "permissions/resources/permission-resource-types";

export abstract class Resource {
  public static generatePermutations<T extends Resource>(
    resourceClass: new () => T,
    fieldIterations: [key: string, value: unknown[]][]
  ): T[] {
    const enumValuesArrays = fieldIterations.map(([_, values]) => values);

    function permutate(arrays: unknown[][], prefix: unknown[] = []): unknown[][] {
      if (!arrays.length) return [prefix];
      const [first, ...rest] = arrays;
      return first.flatMap((value) => permutate(rest, [...prefix, value]));
    }

    const permutations = permutate(enumValuesArrays);
    return permutations.map((perm) => {
      const resource = new resourceClass();
      for (let i = 0; i < fieldIterations.length; i++) {
        const [key] = fieldIterations[i];
        (resource as unknown as Record<string, unknown>)[key] = perm[i];
      }
      return resource;
    });
  }

  public abstract readonly resourceType: ResourceType;

  public readonly resourceId?: Guid;
  public readonly isDisabled: boolean = false;

  public get resourceTypeText(): string {
    return addSpacesToTitleCase(this.resourceType);
  }

  public constructor(params?: BaseResourceParams) {
    if (!params) return;
    this.resourceId = params.resourceId;
    this.isDisabled = !!params.isDisabled;
  }

  public abstract toJSON(): unknown;
  public abstract toString(...params: unknown[]): string;

  public isEqualTo(other: Resource): boolean {
    return JSON.stringify(this) === JSON.stringify(other);
  }
}
